import ethLogo from "../assets/eth.png";

/**
 * Default token list shown in the token selector.
 *
 * Base Sepolia (chain 84532) — matches the deployment in contexts/config.js.
 * Every symbol, name and decimal count below was read off-chain from the token
 * contracts themselves, not assumed.
 *
 * These are TEST tokens. Replace this list when moving to Base mainnet.
 *
 * Pairs that exist on the factory today (factory.getPair, allPairsLength = 3):
 *   USDT  / tDAI   -> 0x62825362ecFe3d4c90f5DcD9e213192CEf97d26b
 *   tUSDC / test   -> 0xbfc5C795d9326909bBc172114c9e7947fF5eEEf8
 *   USDT  / tUSDC  -> 0x094f2016E6c8Df665C9076c398FCb543afD31a1b
 *
 * Any ERC-20 not listed here is still reachable — paste its contract address
 * into the selector's search field and it is imported on the fly. Tokens
 * without an `img` fall back to a lettered avatar in the selector.
 */
export const list = [
    {
        name: "Mock USDT",
        status: true,
        count: 0,
        symbol: "USDT",
        address: "0x1f5CeaEB1eC4b3399544FE061B58E3eAa86E4967",
        // Six, not eighteen — confirmed on-chain. Getting this wrong
        // misprices every quote involving this token by 10^12.
        decimals: 6,
    },
    {
        name: "tDAI",
        status: true,
        count: 0,
        symbol: "tDAI",
        address: "0x8fD15157bc69C4a6d7994AA8876B046167E24c96",
        decimals: 18,
    },
    {
        name: "tUSDC",
        status: true,
        count: 0,
        symbol: "tUSDC",
        address: "0xDEc22dE232B05FfEf7A7fd7569bD568F9F510BA0",
        decimals: 18,
    },
    {
        name: "test",
        status: true,
        count: 0,
        symbol: "test",
        address: "0xA2d649FF254F34EE8AB065bE77Ee4853776fB259",
        decimals: 18,
    },
    {
        name: "Wrapped Ether",
        img: ethLogo,
        status: true,
        count: 0,
        symbol: "WETH",
        address: "0x4200000000000000000000000000000000000006",
        decimals: 18,
    },
];
